import { render, staticRenderFns } from "./btn-radio.vue?vue&type=template&id=d3490f9e&scoped=true&"
import script from "./btn-radio.vue?vue&type=script&lang=ts&"
export * from "./btn-radio.vue?vue&type=script&lang=ts&"
import style0 from "./btn-radio.vue?vue&type=style&index=0&id=d3490f9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3490f9e",
  null
  
)

export default component.exports